import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

export default function CookieBanner() {
  const { t } = useLang();
  const [choice, setChoice] = useState(() => localStorage.getItem("lcp_cookie"));

  const decide = (value) => {
    localStorage.setItem("lcp_cookie", value);
    setChoice(value);
  };

  return (
    <AnimatePresence>
      {!choice && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-md z-[70]"
          data-testid="cookie-banner"
          role="dialog"
          aria-label={t("cookie_title")}
        >
          <div className="bg-surface border border-gold/40 shadow-xl p-6">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-pine">{t("cookie_title")}</p>
            <p className="mt-3 text-sm text-ink-muted leading-relaxed">{t("cookie_text")}</p>
            <div className="mt-5 flex gap-3">
              <button onClick={() => decide("accepted")} className="btn-primary !px-5 !py-2.5 flex-1" data-testid="cookie-accept">
                {t("cookie_accept")}
              </button>
              <button onClick={() => decide("rejected")} className="btn-outline !px-5 !py-2.5 flex-1" data-testid="cookie-reject">
                {t("cookie_reject")}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
